<template lang="html">
  <div class="email-form">
    <form v-if="!sent"
      @submit.prevent="submit"
      class="form-group">
      <label for="">Escribí el correo electrónico donde se te enviará el email de recuperación:</label>
      <input
        v-model="email"
        @keypress.enter.prevent="submit"
        @input="handleInput"
        class="form-control mt-3"
        type="email">
      <div :class="{'error': true, 'show': showError}">
        Ha habido un error
      </div>
      <div class="mt-3 w-100 text-center">
        <button @click.prevent="$emit('close')" class="btn btn-default" type="cancel">
          Cancelar
        </button>
        <button class="btn btn-primary" type="submit">
          Enviar
        </button>
      </div>
    </form>
    <div v-else class="form-group">
      <label for="">En caso de que el correo esté registrado en nuestro sistema enviaremos un email de recuperación de contraseña.</label>
      <div class="mt-4 w-100 text-center">
        <button @click="$emit('close')" class="btn btn-primary">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  data: () => ({
    email: '',
    sent: false,
    showError: false
  }),

  methods: {
    submit () {
      return store.dispatch('user/sendPasswordEmail', this.email)
        .then(({data}) => {
          // return store.dispatch('user/fetchUserInfo')
          this.sent = true
          this.pushToDataLayer('Login dialog', 'Password reset request')
        })
        .catch(er => {
          this.showError = true
        })
    },

    handleInput (e) {
      if (this.showError) this.showError = false
    }
  }
}
</script>

<style lang="scss">
  .email-form {
    & input {
      &:invalid {
        border-color: var(--danger);
      }
    }

    & .error {
      opacity: 0;
      color: var(--danger);
      text-align: center;
      padding-top: 0.5rem;
      padding-bottom: 0;

      &.show {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/EmailForm.vue